<template>
  <div class="Wholesale">
    <div v-if="pifaResult && typeStyle =='default' && (!minRow || minRow < pifaResult.length)" :style="{fontSize: size === 'default' ? '': '10pt'}">
      <div>{{ $t('product.wholesale') }}</div>
      <div v-for="(pifa, index) in pifaResult" :key="pifa.id" :style="{display: 'flex',marginbottom: size === 'default' ?'5px' :'',alignItems: 'center', height: size === 'default' ? '3rem' : '2rem', borderBottom: pifaResult.length-1 != index ? '1px solid #BFBFBF':''}">
        <div :style="{flex:3}">
         {{ pifa.start_num + ' - ' +  pifa.end_num}}  {{ $t('product.num.danwei') }}
        </div>
        <div :style="{flex: size === 'default' ? 2 : 1}" style="text-align: right;">
          <span v-if="pifa.type == 1"><span style="">{{ pifa.price }}%</span><span v-if="size === 'default' ">{{ $t('product.pifa.type.1') }}</span></span> <span v-else-if="pifa.type == 2 "><span >{{ $n(pifa.price || 0, 'currency') }}</span><span v-if="size === 'default'">{{ $t('product.pifa.type.2') }}</span></span>
        </div>
      </div>
    </div>
    <div v-if="pifaResult && typeStyle !=='default'" :style="{fontSize: size === 'default' ? '': '10pt', flex: 'auto'}">
      <div style="display:flex;flex-wrap: wrap;">
        <div style="border-top:2px solid var(--c-primary);">
          <div class="pifaItem" style="background: #F9F9FB;margin-bottom:2px;text-align: right;padding-right:10px;">{{ $t('product.wholesale') }}</div>
          <div class="pifaItem" style="background: #F9F9FB;text-align: right;padding-right:10px;">{{$t('Quantity')}}({{ $t('product.num.danwei') }})</div>
        </div>
        <div v-for="(pifa, index) in pifaResult" :key="pifa.id" style="flex: auto;border-top:2px solid var(--c-primary);">
          <div class="pifaItem pifaItem-price" style="margin-bottom:2px;font-size:12pt;font-weight:600;color: var(--c-primary)">
            <span v-if="pifa.type == 1">
              <template v-if="sku && sku.originalPrice">{{ $n(Number((sku.originalPrice * pifa.price / 100).toFixed(2)) * sku.exchangeRate, 'currency') }}</template>
              <template v-else>{{ pifa.price }}%</template>
            </span>
            <span v-else-if="pifa.type == 2">{{ $n(pifa.price || 0, 'currency') }}</span>
          </div>
          <div class="pifaItem pifaItem-num" style="font-weight:400">{{ pifa.start_num + '-' + pifa.end_num}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useWholesale } from '@bee-hole/coms';
import { onMounted, ref } from '@nuxtjs/composition-api';
import { EventBus } from '@/plugins/eventBus';
export default {
  name: 'Wholesale',
  props: {
    id: {
      default: ''
    },
    size: {
      type: String,
      default: 'default'
    },
    typeStyle: {
      type: String,
      default: 'default'
    },
    minRow: {
      type: Number,
      default: 0
    }
  },
  setup({ id }) {
    const { result: pifaResult, goodWholesaleGet1 } = useWholesale(id);
    const sku = ref();
    onMounted(async () => {
      await goodWholesaleGet1({ good_id: id });
    });
    onMounted(async () => {
      EventBus.$on('SkuChange', async (data) => {
        if (data && data.sku && data.sku.skuId) {
          sku.value = data.sku;
        }
      });
    });
    return {
      pifaResult,
      sku
    };
  }
};
</script>

<style lang="scss" >
.Wholesale{
  @include for-mobile {
    padding: 0 var(--spacer-sm);
  }
}
 .pifaItem{
   background: #F9F9FB;
   height: 3rem;
   align-content: center;
   min-width: 4rem;
   justify-content: center;
   text-align: center;
   font-size: 0.8rem;
   display: grid;
 }
</style>
